import React from 'react';
import { GoogleApiWrapper, InfoWindow, Map, Marker } from 'google-maps-react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';




const GOOGLE_MAPS_JS_API_KEY='AIzaSyCWCu2mMfPB0twxHyFuvk6mbB-o_bBqITM';

class GoogleMapsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {}
    }

    console.log('props goolge')
    console.log(this.props)
    console.log(this.props.hotel.Latitud)
    console.log(this.props.hotel.Longitud)

    console.log(this.props.hotel.hotel)

    // binding this to event-handler functions
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onMapClick = this.onMapClick.bind(this);
  }
  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }
  onMapClick = (props) => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null
      });
    }
  }
  render() {
 
    const style = {
      width: '600px',
      height: '500x'
    }
    const styleDetails = {
      width: '600px',
      height: '436x'
    }

    const containerStyle = {
      width: '600px',
      height: '436px'
    }

    const styleDiv = {
      width: '600px',
      height: '500px',
      overflow: 'hidden'
    }

    const styleDivDetails = {
      width: '600px',
      height: '436px',
      overflow: 'hidden'
    }


    const appBar = {
      position: 'relative',
      backgroundColor: '#FE5215'
    }

    const TituloHotel = {
      color: 'white'
    }

    const hotelMarker = {
      color: '#016AA2',
      fontWeight: 'bolder'
    }

    const Address = {
            fontStyle: 'oblique'
    }

    return (
        <div style={this.props.bar ? styleDiv : styleDivDetails}>
      {this.props.bar ? <AppBar style={appBar}>
          <Toolbar>
            <Typography variant="h6" style={TituloHotel}>
                  {this.props.hotel.nombreHotel}
                </Typography>
          </Toolbar>
        </AppBar> 
        :
        null
    }
          <Map
            containerStyle={containerStyle}
            item
            xs={12}
            style={this.props.bar ? style : styleDetails}
            google={this.props.google}
            onClick={this.onMapClick}
            zoom={14}
            scroll='body'
            initialCenter={{
              lat: this.props.hotel.Latitud,
              lng: this.props.hotel.Longitud
            }}
          >
            <Marker
              onClick={this.onMarkerClick}
              title={'Changing Colors Garage'}
              position={{
                lat: this.props.hotel.Latitud,
                lng: this.props.hotel.Longitud
              }}
              name={'Changing Colors Garage'}
            />
            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
            >
              <Paper>
                <Typography
                  component='h5'
                  style={hotelMarker}
                >
                                  {this.props.hotel.nombreHotel}
            </Typography>
                <Typography
                  component='body1'
                >
                  {this.props.hotel.Direccion}
            </Typography>
              </Paper>
            </InfoWindow>
          </Map>
        </div> 
    );
  }
}
/* export default GoogleApiWrapper({
  api: (GOOGLE_MAPS_JS_API_KEY)
})(GoogleMapsContainer) */

export default GoogleApiWrapper(props => ({
  apiKey: GOOGLE_MAPS_JS_API_KEY,
}))(GoogleMapsContainer);